import { render, staticRenderFns } from "./List.vue?vue&type=template&id=c30ff9bc"
import script from "./List.js?vue&type=script&lang=js&external"
export * from "./List.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports